import { useCallback, useEffect, useState } from "react";
import { avisarError } from "../../shared/errores";
import { comentar, eliminarComentario, listarComentarios } from "./proyectosService";
import { Avatar } from "./componentes";
import { botonFantasma, campo, tituloPanel } from "./estilos";
import { fechaHora } from "./reglas";
import { confirmar } from "../../shared/avisos";

// Conversación de una tarea: cualquiera con la sección comenta.
function Comentarios({ tareaId, puedeBorrar, onCambio }) {
  const [comentarios, setComentarios] = useState([]);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);

  const cargar = useCallback(() => {
    listarComentarios(tareaId).then(setComentarios).catch(avisarError);
  }, [tareaId]);

  useEffect(() => { cargar(); }, [cargar]);

  const enviar = async () => {
    if (!texto.trim()) return;
    setEnviando(true);
    try {
      await comentar(tareaId, texto);
      setTexto("");
      cargar();
      onCambio?.();
    } catch (error) {
      avisarError(error);
    } finally {
      setEnviando(false);
    }
  };

  const eliminar = async (comentario) => {
    if (!(await confirmar("¿Eliminar este comentario?", { aceptar: "Eliminar" }))) return;
    try {
      await eliminarComentario(comentario.id);
      cargar();
      onCambio?.();
    } catch (error) {
      avisarError(error);
    }
  };

  return (
    <div>
      <h4 className={`${tituloPanel} mb-4`}>Comentarios</h4>
      <div className="mb-4 space-y-4">
        {comentarios.map((c) => (
          <div key={c.id} className="group flex gap-3">
            <Avatar nombre={c.autor} />
            <div className="min-w-0 flex-1">
              <p className="text-xs text-gray-500">
                <span className="font-bold text-gray-300">{c.autor || "Usuario"}</span> · {fechaHora(c.creado_en)}
                {puedeBorrar(c) && (
                  <button type="button" onClick={() => eliminar(c)} className="ml-2 transition hover:text-rose-400 sm:opacity-0 sm:group-hover:opacity-100">Eliminar</button>
                )}
              </p>
              <p className="mt-0.5 whitespace-pre-line text-sm text-gray-200">{c.texto}</p>
            </div>
          </div>
        ))}
        {!comentarios.length && <p className="text-sm text-gray-500">Sin comentarios aún.</p>}
      </div>
      {/* No es un <form>: la ventana de la tarea ya es un formulario. */}
      <div className="flex gap-2">
        <input
          className={campo}
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); enviar(); } }}
          placeholder="Escribe un comentario…"
          aria-label="Comentario"
        />
        <button type="button" onClick={enviar} disabled={enviando || !texto.trim()} className={botonFantasma}>Enviar</button>
      </div>
    </div>
  );
}

export default Comentarios;
